<div class="header">
    <app-section-header
        [title]="title()"
        [titleStyle]="'tertiary'"
        [iconName]="type() === 'newProjects' ? 'newProjects' : 'hourglass'"
    >
    </app-section-header>
</div>

<div class="grid" #gridHost>
    <app-client-side-grid
        [rowData]="dashboardOpportunities()"
        [columnDefs]="columnDefs()"
        [defaultColDef]="defaultColDef"
        [domLayout]="'autoHeight'"
        [autoSizeStrategy]="{ type: 'fitGridWidth', defaultMinWidth: 100 }"
        [suppressHorizontalScroll]="true"
    ></app-client-side-grid>
</div>
